import ResponsiveDialog from '@sophocles/components/ResponsiveDialog/ResponsiveDialog';
export default ResponsiveDialog;
